var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloudOffline = function SvgCloudOffline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4.6 11.6A3.6 3.6 0 0 1 1 8v0a3.6 3.6 0 0 1 3.84-3.6 4.8 4.8 0 0 1 8.9 1.64 2.8 2.8 0 1 1 .46 5.56M12.2 8.4 6.6 14M6.6 8.4l5.6 5.6",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgCloudOffline;